export default __webpack_public_path__ + "static/media/empty_state.05726ff6.png";